import { fetchParams } from '../../../../api/resultApiUser.api.js';
import Validatable from '../../../mixins/Validatable.js';
import ContentLoader from '../../../mixins/ContentLoader.js';
import ResultApiUserForm from '../../../components/resultApiUser/ResultApiUserForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
	components: {
		ValidationObserver,
		ResultApiUserForm
	},
	mixins: [Validatable, ContentLoader],
	data() {
		return {
			user: {
				username: '',
				domain: '',
				password: '',
				serverId: ''
			},
			params: {
				servers: []
			}
		};
	},
	methods: {
		async fetchParams() {
			try {
				const response = await fetchParams(),
					{ servers } = response.data;

				this.params.servers = servers;
			} catch (e) {
				console.error(e);
			}
		}
	}
};
